import { Roles } from '~/data/user';

const isRole = (expectedRole: Roles) => (userRoles: Roles[] | string[]) =>
  userRoles.includes(expectedRole);

export const hasOneOfRoles = (
  roles: Roles[] | string[],
  expectedRoles: Roles[],
) => expectedRoles.some((role) => roles.includes(role));

export const isRoleDepManager = isRole(Roles.DEPUTY_MANAGER);
export const isRoleAltManager = isRole(Roles.ALT_MANAGER);
export const isRoleManager = (userRoles: Roles[] | string[]) =>
  isRole(Roles.MANAGER)(userRoles) || isRoleAltManager(userRoles);
export const isRoleHRAdminFull = isRole(Roles.HR_ADMIN);
export const isRoleHRAdminLimited = isRole(Roles.HR_ADMIN_LIMITED);
export const isRoleHRAdmin = (userRoles: Roles[] | string[]) =>
  isRoleHRAdminFull(userRoles) || isRoleHRAdminLimited(userRoles);
export const isRoleDevHR = isRole(Roles.HR_DEV);
export const isRolePeopHR = isRole(Roles.HR_PEOP);
export const isRolePeopDevHR = isRole(Roles.HR_PEOP_DEV);
export const isRoleStaffHR = isRole(Roles.HR_STAFF);
export const isRoleHR = (userRoles: Roles[] | string[]) =>
  isRoleStaffHR(userRoles) ||
  isRoleDevHR(userRoles) ||
  isRolePeopHR(userRoles) ||
  isRolePeopDevHR(userRoles) ||
  isRoleHRAdmin(userRoles);
export const isRoleITAdmin = isRole(Roles.IT_ADMIN);
export const isRoleRecruiter = isRole(Roles.RECRUITER);
export const isRoleHRSalary = isRole(Roles.HR_SALARY);

export const isEmployee = (roles: string[]): boolean =>
  roles.some((role) => role === 'EMPLOYEE');

export const isHR = (roles: string[]): boolean =>
  roles.some((role) => role.startsWith('HR_') && role !== 'HR_SALARY');

export const isResponsibleManager = (roles: string[]): boolean =>
  roles.some((role) => role.endsWith('_MANAGER'));

export const isStraightManager = (roles: string[]): boolean =>
  roles.some((role) => role === 'MANAGER');
